/**
 * Order Detail Response Types
 *
 */
import type { ResponseWithData } from '../utilities';

// Private Types

enum DELIVERY_MODE {
  DELIVERY = 'delivery',
  TAKEAWAY = 'takeaway',
}

enum INVOICE_STATUS {
  AVAILABLE_BILLING = 'availableBilling',
  BILLED = 'billed',
  CANCELED = 'canceled',
  DONATION_INSUED = 'donationIsued',
  NOT_BILLED = 'notBilled',
  RETURNED = 'returned',
  TRANSFER_REQUEST = 'transferRequest',
}

enum ITEM_TYPE {
  CUT = 'cut',
  GIFT = 'gift',
  STANDARD = 'standard',
}

export enum ORDER_STATUS {
  CANCELED = 'canceled',
  CAPTURE = 'capture',
  DELIVERED = 'delivered',
  DELIVERING = 'delivering',
  OPEN = 'open',
  PAYMENT_PROCESS = 'paymentProcess',
  PICKING = 'picking',
  PROCESSING = 'processing',
  STOCK_LOCKED = 'stockLocked',
}

enum PAYMENT_STATUS {
  OPEN = 'open',
  CLOSED = 'closed',
  PAID = 'paid',
}

enum TITLE_STATUS {
  OVERDUE = 'overdue',
  NOTOVERDUE = 'notOverdue',
}

interface DeliveryAddress {
  city: string;
  complement: string;
  deliveryMode: DELIVERY_MODE;
  district: string;
  fullAddress: string;
  number: number;
  place: string;
  postalCode: string;
  shippingCompany: string;
  state: string;
}

interface OrderItem {
  description: string;
  distributionCenter: string;
  imageUrl: string;
  invoiceStatus: INVOICE_STATUS;
  quantity: number;
  sku: string;
  totalPrice: number;
  type: ITEM_TYPE;
  typeDetail: string;
  unitPrice: number;
}

interface OrderPayloadResponse {
  amount: number;
  billingDate: string;
  chargeRateAmount: number;
  code: string;
  creditAmount: number;
  cycle: string;
  dateTime: string;
  deliveryAddress: DeliveryAddress;
  deliveryDate: string;
  externalId: string;
  id: string;
  invoiceFileLink: string;
  invoiceNumber: string;
  items: OrderItem[];
  paymentAmount: number;
  payments: Payment[];
  profit: number;
  profitPercentage: number;
  status: ORDER_STATUS;
  statusDetail: string;
  subTotal: number;
  tracking: Tracking[];
}

interface Payment {
  amount: number;
  dueDate: string;
  id: string;
  installments: number;
  link: string;
  name: string;
  titles: Title[];
  type: PAYMENT_PLAN_TYPE;
}

interface Title {
  paymentStatus: PAYMENT_STATUS;
  plan: string;
  status: TITLE_STATUS;
  totalBalance: number;
}

interface Tracking {
  date: string;
  detail: string;
  status: ORDER_STATUS;
}

// Root Payload Response Type

export type OrderResponse = ResponseWithData<OrderPayloadResponse>;
